/**
 * These are meant to be used as CSS classes.
 * @enum {string}
 */
export const SegmentSize = {
  MEDIUM: 'medium',
  LARGE: 'large',
};
